module.exports = __webpack_public_path__ + "img/phone-list-bag.c0c1a1a3.webp";